// @flow
import { alerts, feedback } from '~/core/constants';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { cancelSaveSchedule, completeSaveSchedule } from './actions';
import { getCleanSchedule, getCurrentScheduleEvent, getDataId } from './selectors';
import { getModeForProduct, getTypeForProduct } from '~/core/state/products/selectors';

import { ATTEMPT_SAVE_SCHEDULE } from './constants';
import type { AttemptSaveScheduleAction } from './types';
import { deviceModes } from '~/core/constants/devices';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { modifyProductState } from '~/core/state/products/actions';
import { noop } from 'lodash/fp';
import { patchProduct } from '~/core/api/products/products.api';
import { requestAlert } from '~/core/state/alerts/actions';

/*********************
 *   SAVE SCHEDULE   *
 *********************/

export function* attemptSaveScheduleSaga({
    payload: { componentId }
}: AttemptSaveScheduleAction): Generator<noop | Effect, *, *> {
    const schedule = yield select(getCleanSchedule, { componentId });
    const productId = yield select(getDataId, { componentId });
    const productType = yield select(getTypeForProduct, { id: productId });

    const [, error] = yield call(handleApi(patchProduct), { schedule }, productType, productId);

    if (error) {
        yield put(requestAlert(feedback.generic.UNEXPECTED_ERROR, alerts.types.ERROR));
        yield put(cancelSaveSchedule(componentId));
        return;
    }
    yield put(completeSaveSchedule({ componentId }));

    // now update the product state if the device mode is set as SCHEDULE
    const productMode = yield select(getModeForProduct, { id: productId });
    if (productMode !== deviceModes.SCHEDULE) {
        return;
    }
    const currentEvent = yield select(getCurrentScheduleEvent, {
        componentId,
        saved: true
    });
    yield put(
        modifyProductState({
            productId,
            productStateChanges: currentEvent.get('value').toJS()
        })
    );
}

function* watchAttemptSaveScheduleSaga(): Generator<Effect, *, *> {
    yield takeEvery(ATTEMPT_SAVE_SCHEDULE, handleSaga(attemptSaveScheduleSaga));
}

/*************************/

export default [watchAttemptSaveScheduleSaga];



// WEBPACK FOOTER //
// ./src/core/state/ui/schedule/sagas.js